export default title => (document.title = `denis onder - ${title}`);
